import { rangeWithDefaultsWhenEmpty } from '../engine/default-handlers';
import { defineFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

const DEFAULT_MIN_HEADCOUNT = 0;
const DEFAULT_MAX_HEADCOUNT = 10000;

export const headcountDescriptor = defineFilter({
  definition: {
    id: FilterId.HEADCOUNT,
    name: 'Headcount',
    type: FilterType.RANGE,
    min: DEFAULT_MIN_HEADCOUNT,
    max: DEFAULT_MAX_HEADCOUNT,
    isActive: false,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_HEADCOUNT, segmented: true },
  handler: rangeWithDefaultsWhenEmpty(
    DEFAULT_MIN_HEADCOUNT,
    DEFAULT_MAX_HEADCOUNT
  ),
});
